import React from 'react';
import PropTypes from 'prop-types';
import Picture, { cdn } from '@deporvillage/picture-component';
import { Config } from '@deporvillage/utils-library-component';

import styles from './ImageZoom.module.scss';

const DefaultSize = 1800;

const getInit = ({ image, cdnConfig }) => ({
    zoom: false,
    backgroundPosition: '0% 0%',
    backgroundSize: '0 0',
    backgroundImage: `url(${cdn({ src: `product/${image}` }, cdnConfig,)})`,
    backgroundRepeat: 'no-repeat',
    zIndex: '1',
});


const ImageZoom = ({ image, zoomOnHover, showBorder, size, zoomSize, onClick }) => {

    const { cdn: cdnConfig } = React.useContext(Config);
    const [state, setState] = React.useState(getInit({ image, cdnConfig }));

    const enableZoom = (ev) => {
        let { left, top, width, height } = ev.target.getBoundingClientRect();
        let x = ((ev.pageX - left) / width) * 100;
        let y = ((ev.pageY - window.scrollY - top) / height) * 100;
        setState({
            ...state,
            zoom: true,
            backgroundSize: `${zoomSize}px ${zoomSize}px`,
            backgroundPosition: `${x}% ${y}%`,
            zIndex: '2',
        });
    };

    const disableZoom = () => setState({
        ...state,
        zoom: false,
        backgroundSize: '0 0',
        backgroundPosition: '0% 0%',
        zIndex: '1',
    });
 
    const handleOnMouseMove = (ev) => (zoomOnHover || !zoomOnHover && state?.zoom) && enableZoom(ev);
    const handleOnMouseLeave = () => zoomOnHover && disableZoom();

    const handleOnClick = (ev) => {
        if (!zoomOnHover) {
            if (state.zoom) disableZoom();
            else enableZoom(ev);
        }
        onClick && onClick();
    };

    React.useEffect(() => {
        image && setState(getInit({ image, cdnConfig }));
    }, [image]);

    return (
        <div
            style={state}
            className={`${styles['image-zoom-component']} ${state.zoom ? styles.zoom : ''} ${zoomOnHover ? styles.hover : ''} ${showBorder ? styles.border : ''}`}
            data-testid='click-to-open'
            onClick={handleOnClick}
            onMouseMove={handleOnMouseMove}
            onMouseLeave={handleOnMouseLeave}
        >
            <div className={state.zoom ? styles['hide-picture'] : ''}>
                {
                    <Picture
                        name='picture'
                        src={`product/${image}`}
                        width={!state.zoom && size || DefaultSize}
                        height={!state.zoom && size || DefaultSize}
                        priority={'high'}
                    />
                }
            </div>
        </div>
    );
};
ImageZoom.propTypes = {
    image: PropTypes.string,
    size: PropTypes.number,
    zoomSize: PropTypes.number,
    zoomOnHover: PropTypes.bool,
    showBorder: PropTypes.bool,
    onClick: PropTypes.func,
};

export default ImageZoom;
